import axios from 'axios';

const DATA_ATTR    = 'data-blog-list';
const CLASS_PREFIX = 'blog-list';

document.querySelectorAll(`[${DATA_ATTR}]`).forEach(initBlogList);

export function initBlogList(container) {
    const tpl        = container.querySelector(`[${DATA_ATTR}-product-cart-template]`).content;
    const listEl     = container.querySelector(`[${DATA_ATTR}-list]`);
    const pagination = container.querySelector(`[${DATA_ATTR}-pagination]`);
    const loader     = container.querySelector(`[${DATA_ATTR}-loader]`);

    let currentPage = 1;
    let lastPage    = 1;
    const perPage   = 12; // тут ваш тест

    function renderItems(items) {
        listEl.innerHTML = '';
        items.forEach(item => {
            const clone = document.importNode(tpl, true);
            clone.querySelector(`[${DATA_ATTR}-card]`).href          = item.url;
            clone.querySelector(`[${DATA_ATTR}-image]`).src         = item.image;
            clone.querySelector(`[${DATA_ATTR}-title]`).textContent = item.title;
            clone.querySelector(`[${DATA_ATTR}-date]`).textContent  = item.date;
            clone.querySelector(`[${DATA_ATTR}-desc]`).textContent  = item.description;
            listEl.appendChild(clone);
        });
    }

    function renderPagination(meta) {
        pagination.innerHTML = '';

        currentPage = parseInt(meta.current_page, 10) || 1;
        lastPage    = parseInt(meta.last_page,    10) || 1;

        // «‹»
        const prev = document.createElement('button');
        prev.type        = 'button';
        prev.textContent = '‹';
        prev.disabled    = currentPage <= 1;
        prev.addEventListener('click', () => fetchPage(currentPage - 1));
        pagination.appendChild(prev);

        // цифры
        for (let i = 1; i <= lastPage; i++) {
            const btn = document.createElement('button');
            btn.type        = 'button';
            btn.textContent = i;
            if (i === currentPage) {
                btn.classList.add(`${CLASS_PREFIX}__page--active`);
                btn.disabled = true;
            }
            btn.addEventListener('click', () => fetchPage(i));
            pagination.appendChild(btn);
        }

        // «›»
        const next = document.createElement('button');
        next.type        = 'button';
        next.textContent = '›';
        next.disabled    = currentPage >= lastPage;
        next.addEventListener('click', () => fetchPage(currentPage + 1));
        pagination.appendChild(next);
    }

    async function fetchPage(page = 1) {
        loader.hidden = false;
        try {
            const p = parseInt(page, 10) || 1;
            console.log(`[BlogList] fetchPage p=${p} per_page=${perPage}`);
            const url = `/api/blogs?page=${p}&per_page=${perPage}`;
            const resp = await axios.get(url);
            const { data, meta } = resp.data;

            renderItems(data);
            renderPagination(meta);

            // меняем URL без перезагрузки
            const u = new URL(window.location);
            u.searchParams.set('page', p);
            window.history.replaceState({}, '', u);
        } catch (err) {
            console.error('Ошибка загрузки блогов:', err);
        } finally {
            loader.hidden = true;
        }
    }

    // стартуем с URL-параметра
    const init = parseInt(new URL(window.location).searchParams.get('page'), 10) || 1;
    fetchPage(init);
}
